import { LevelBordersType } from './HierarchyCard.type'

const LEVEL_BORDERS: LevelBordersType = {
  '0': {
    color: '#000000',
    width: '0'
  },
  '1': {
    color: '#C9C9CB',
    width: '1px'
  },
  '2': {
    color: '#BCBCBE',
    width: '1px'
  },
  '3': {
    color: '#AFAFB2',
    width: '1px'
  },
  '4': {
    color: '#A3A3A5',
    width: '1px'
  },
  '5': {
    color: '#969698',
    width: '1px'
  },
  '6': {
    color: '#7C7C7F',
    width: '1px'
  },
  '7': {
    color: '#636365',
    width: '1px'
  },
  '8': {
    color: '#49494C',
    width: '1px'
  }
}

export const LEVEL_DEFAULT = 1

export const getLevelIds = () => Object.keys(LEVEL_BORDERS)

export const getBorderWidth = (level: number) =>
  LEVEL_BORDERS[level.toString()]?.width ||
  LEVEL_BORDERS[LEVEL_DEFAULT.toString()].width

export const getBorderColor = (level: number) =>
  LEVEL_BORDERS[level.toString()]?.color ||
  LEVEL_BORDERS[LEVEL_DEFAULT.toString()].color
